import { FETCH_RAINPRO_SCHEMES, CLEAN_RAINPRO_SCHEMES, CHANGE_RAINPRO_SCHEME, DELETE_RAINPRO_SCHEME } from '../actions/types';
import _ from 'lodash';
import { toNumber } from '../functions';

const RAINPRO_SCHEMES_DEFAULT_STATE = {};

const RainproSchemesReducer = (state = RAINPRO_SCHEMES_DEFAULT_STATE, { type, payload }) => {
    switch (type) {
        case FETCH_RAINPRO_SCHEMES:
            return payload;

        case CHANGE_RAINPRO_SCHEME:
            return { ...state, items: _.map(state.items, item => {
                if (toNumber(item.id) === toNumber(payload.id)) {
                    item = { ...item, data: payload.data };
                }

                return item;
            }) };

        case CLEAN_RAINPRO_SCHEMES:
        case DELETE_RAINPRO_SCHEME:
            return RAINPRO_SCHEMES_DEFAULT_STATE;

        default:
            return state;
    }
};

export default RainproSchemesReducer;
